<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter searchPlaceholder="Tìm kiếm mã đơn hàng, mã vận đơn, khách hàng..." :orderbutton="true" :listStatus="listStatus" :headers="filter_headers" :viewName="viewName" :orderSummary="orderSummary" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-widget title="Thống kê chi phí" v-if="selectedOrders.length > 0">
              <div slot="widget-content">
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Số đơn hàng:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.length}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Tổng tiền:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Tổng tiền hàng:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.AmountVND).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Đã cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Cần cọc:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{selectedOrders.map(item => item.MinDeposit).reduce((prev, curr) => prev + curr, 0) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0>
                        <v-card-text>Còn thiếu:</v-card-text>
                    </v-flex>
                    <v-flex lg9 sm9 pa-0>
                        <v-card-text>{{(selectedOrders.map(item => item.TotalAmountVND).reduce((prev, curr) => prev + curr, 0) - selectedOrders.map(item => item.Deposit).reduce((prev, curr) => prev + curr, 0)) | currency}}</v-card-text>
                    </v-flex>
                  </v-layout>
                  <v-layout class="font-weight-bold" row wrap>
                    <v-flex lg3 sm3 pa-0 pl-4>
                        <a href="javascript:void(0)" @click="depositDialog">Cập nhật đơn hàng</a>
                    </v-flex>
                    <v-flex lg3 sm3 pa-0 pl-4 v-if="paymentRole || adminRole || managerRole || purchaseRole">
                        <a href="javascript:void(0)" @click="deleteOrder">Xoá đơn hàng</a>
                    </v-flex>
                  </v-layout>
              </div>
          </v-widget>
          <v-data-table
            :headers="headers"
            :items="orders"
            :must-sort="true"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :loading="loading"
            show-select
            :mobile-breakpoint="100"
            v-model="selectedOrders"
            item-key="ID"
            class="elevation-1"
          >
            <template v-slot:item="{ item, isSelected, select}">
              <tr :active="isSelected">
                <td @click="select(!isSelected)"><v-checkbox primary hide-details :input-value="isSelected"></v-checkbox></td>
                <td><a target="_blank" :href="'/don-hang/' + item.ID">{{ (item.LineType == 'chinh_ngach' ? 'CN' : 'MD')+item.ID }}</a></td>
                <td>{{ item.LineType | display_value(line_types) }}</td>
                <!-- <td>
                  <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                </td> -->
                <td>
                  <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                  <p>Lên đơn: {{ item.CreatedDate | display_date }}</p>
                  <p v-if="item.DepositDate">Cọc đơn: {{ item.DepositDate | display_date }}</p>
                  <p v-if="item.BoughtDate">Mua hàng: {{ item.BoughtDate | display_date }}</p>
                  <p v-if="item.ShopDeliverDate">Phát hàng: {{ item.ShopDeliverDate | display_date }}</p>
                  <p v-if="item.StoreCNImDate">Nhập kho TQ: {{ item.StoreCNImDate | display_date }}</p>
                  <!-- <p v-if="item.StoreCNExDate">Xuất kho TQ: {{ item.StoreCNExDate | display_date }}</p> -->
                  <p v-if="item.StoreVNImDate">Nhập kho VN: {{ item.StoreVNImDate | display_date }}</p>
                  <p v-if="item.PayDate">Thanh toán: {{ item.PayDate | display_date }}</p>
                  <p v-if="item.StoreVNExDate">Xuất kho VN: {{ item.StoreVNExDate | display_date }}</p>
                  <p v-if="item.CompletedDate">Hoàn thành: {{ item.CompletedDate | display_date }}</p>
                </td>
                <td>
                  <v-img :src="proxyImage(item.image_origin)" width="64px" height="64px"></v-img>
                </td>
                <td class="font-weight-bold">
                  <p v-if="item.OrgID">Được tạo từ đơn: <a target="_blank" :href="'/don-hang/' + item.OrgID">{{ (item.LineType == 'chinh_ngach' ? 'CN' : 'MD')+item.OrgID }}</a></p>
                  <p>Tỷ giá: {{ item.ExchangeRate | currency}}</p>
                  <p>Tiền hàng: {{ item.AmountCNY | currency('¥',2)}}</p>
                  <p>Tổng tiền: {{ item.TotalAmountVND | currency }}</p>
                  <p class="blue--text">Đã trả: {{ item.Deposit | currency }}</p>
                  <p class="red--text">Còn lại: {{ (item.TotalAmountVND - item.Deposit) | currency }}</p>
                  <p>Shop TQ: {{ item.ShopName }}</p>
                  <p>Website: {{ item.Site }}</p>
                </td>
                <td class="font-weight-bold">
                  <p class="blue--text">{{ item.UID }} - {{ item.Username }}</p>
                  <p>{{item.CustomerName}}</p>
                  <p v-if="adminRole || paymentRole">{{item.Email}}</p>
                  <p v-if="adminRole || paymentRole || storeVNRole">{{item.PhoneNumber}}</p>
                  <p v-if="adminRole || paymentRole || storeVNRole">{{item.Address}}</p>
                </td>
                <td>
                  <p><v-select :disabled="!(orderRole & 512)" dense solo label="Mua hàng" :items="p_staffs" v-model="item.BuyerID" item-text="FullName" item-value="ID" v-on:change="saveItem({OrderID: item.ID, BuyerID: item.BuyerID})"></v-select></p>
                  <p><v-select :disabled="!(orderRole & 512)" dense solo label="CSKH" :items="cs_staffs" v-model="item.CustomerServiceID" item-text="FullName" item-value="ID" v-on:change="saveItem({OrderID: item.ID, CustomerServiceID: item.CustomerServiceID})"></v-select></p>
                  <p><v-select :disabled="!(orderRole & 512)" dense solo label="Sale" :items="s_staffs" v-model="item.SalerID" item-text="FullName" item-value="ID" v-on:change="saveItem({OrderID: item.ID, SalerID: item.SalerID})"></v-select></p>
                </td>
                <td>
                  <template v-if="!saleRole">Mã đơn hàng:<p v-if="item.OrderCodeCN" v-html="item.OrderCodeCN.replaceAll(';', '<br>')"></p></template>
                  Mã bao hàng:<p v-if="item.BigPackageCode" v-html="item.BigPackageCode.replaceAll(';', '<br>')"></p>
                  Mã vận đơn:<p v-if="item.TransactionCode" v-html="item.TransactionCode.replaceAll(';', '<br>')"></p>
                </td>
                <td>
                  <v-textarea
                    v-model="item.AdminNote"
                    label="Ghi chú"
                    class="input-group--focused"
                    @change="saveItem({OrderID: item.ID, AdminNote: item.AdminNote})"
                  ></v-textarea>
                </td>
                <!-- <td>
                  {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                  <br v-if="item.IsFragileGoods" />
                  {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                  <br v-if="item.IsCheck" />
                  {{ item.GuaranteeType ? 'Bảo hiểm' : '' }}
                </td> -->
                <td class="text-center">
                  <v-tooltip top>
                      <template v-slot:activator="{ on }">
                          <v-icon medium @click="gotoDetail(item.ID)" v-on="on">fa-external-link-alt</v-icon>
                      </template>
                      <span>Chi tiết đơn hàng</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogExport" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Xuất file</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <div>Ngày tạo đơn</div>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Từ ngày" v-model="export_options.start_date" :rules="date_validation"></v-text-field>
              </v-flex>
              <v-flex lg6>
                <v-text-field label="Đến ngày" v-model="export_options.end_date" :rules="date_validation"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogExport = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="exportFile">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogNew" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="title">Tạo mới đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg4 md4 sm12>
                <v-autocomplete label="Khách hàng" v-model="newOrder.UID" :items="customers" item-text="Username" item-value="ID"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12>
                <p class="body-2 font-weight-bold text-red">Danh sách sản phẩm</p>
                <v-list>
                  <v-list-item v-for="(item, index) in newOrder.Products" :key="item.ID">
                    <v-list-item-content>
                      <v-flex lg2 md2 sm12>
                    <v-text-field label="Link sản phẩm" v-model="item.Link"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <!-- <v-text-field label="Link ảnh" v-model="item.Image"></v-text-field> -->
                      <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="`${getImages(index)}`" ref="imageFile"/>
                    </v-flex>
                    <v-flex lg4 md4 sm12>
                      <v-text-field label="Thuộc tính" v-model="item.Property"></v-text-field>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="item.Price"></h-currency-input>
                    </v-flex>
                    <v-flex lg2 md2 sm12>
                      <h-currency-input label="Số lượng" :decimal="0" v-model="item.Quantity"></h-currency-input>
                    </v-flex>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="newOrder.Products.splice(index, 1);">
                        <v-icon>fa-trash-alt</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-layout row wrap>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link sản phẩm" v-model="newProduct.Link"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <v-text-field label="Link ảnh" v-model="newProduct.Image"></v-text-field>
                  </v-flex>
                  <v-flex lg2 md2 sm12>
                    <div class="col-md-12 box-right fb flex-c text-red form-group" style="padding: 0;">
                        <div class="row">
                            <div class="col-md-4">
                                <img style="max-width: 56px; max-height: 56px" v-if="!hideImage" v-bind:src="newProduct.Image" ref="imageFile"/>
                            </div>
                            <div class="col-md-8">
                                <input type="file" ref="fileInput" style="display: none" @change="previewImage" accept="image/*" > 
                                <button @click="chooseImage(newProduct)" style="cursor: point">Tải ảnh</button>
                            </div>
                        </div>
                    </div>
                  </v-flex>
                  <v-flex lg3 md3 sm12>
                    <v-text-field label="Thuộc tính" v-model="newProduct.Property"></v-text-field>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Đơn giá (¥)" :decimal="1" v-model="newProduct.Price"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <h-currency-input label="Số lượng" :decimal="0" v-model="newProduct.Quantity"></h-currency-input>
                  </v-flex>
                  <v-flex lg1 md1 sm12>
                    <v-btn icon large @click="appendProduct"><v-icon color="#dc3545">far fa-plus-square</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogNew = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="createNewOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <upload-file :dialogUpload="dialogImport" title="Import đơn hàng" temp_file="don_hang_mau.xls" @closePopup="dialogImport=false" @importFile="importFile"></upload-file>
    <v-dialog v-model="dialogDeposit" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Cập nhật đơn hàng</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-select v-model="selectedActionType" :items="bulkActionType" item-value="value" item-text="name"></v-select>
              </v-flex>
              <v-flex lg12>
                <!-- <h-currency-input v-if="selectedActionType == 1" label="Tổng tiền cọc (₫)" v-model="actionValueNumber" :decimal="0"></h-currency-input> -->
                <h-currency-input v-if="selectedActionType == 2" label="Tỷ giá tệ" v-model="actionValueNumber" :decimal="0"></h-currency-input>
                <!-- <h-currency-input v-if="selectedActionType == 3" label="Lãi tỷ giá" v-model="actionValueNumber" :decimal="0"></h-currency-input> -->
                <h-currency-input v-if="selectedActionType == 4" label="Tỷ lệ cọc (%)" v-model="actionValueNumber" :decimal="0"></h-currency-input>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogDeposit = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="depositBlance">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import VWidget from "@/components/VWidget";
import upload_file from "@/components/popups/upload_file";
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import Filtering from "@/components/Filtering";
import { sendErrorNotice, sendSuccessNotice, makeid, proxyImage } from "@/commons/utils";
import firebase from 'firebase';
import moment from "moment";
export default {
  components: {
    VWidget,
    "hpo-filter": Filtering,
    "upload-file": upload_file,
  },
  data() {
    return {
      proxyImage: proxyImage,
      dialogDeposit: false,
      imageData: null,
      hideImage: false,
      search: "",
      selectedOrders: [],
      selectedActionType: 1,
      headers: [       
        {
          text: "ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Loại đơn",
          value: "LineType",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.LINE_TYPES
        },
        {
          text: "Trạng thái",
          value: "Status",
          width: 220,
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.ORDER_STATUS
        },
        {
          text: "Ảnh SP",
          value: "image_origin",
          sortable: false,
          filterable: false,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thông tin",
          value: "TotalAmountVND",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"],
          width: "200px"
        },
        {
          text: "Thông tin khách",
          value: "UID",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Nhân viên",
          value: "BuyerName",
          quickSearch: true,
          filterable: true,
          width: "180px",
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã đơn TQ & vận đơn",
          value: "OrderCodeCN",
          quickSearch: true,
          filterable: true,
          width: 120,
          dataType: configs.DATA_TYPE["String"]
        },
        // {
        //   text: "Ngày",
        //   value: "CreatedDate",
        //   filterable: true,
        //   dataType: configs.DATA_TYPE["Date"],
        //   width: "230px"
        // },
        {
          text: "Ghi chú đơn",
          value: "AdminNote",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
          width: "130px"
        },
        // {
        //   text: "Lưu ý",
        //   sortable: false,
        //   filterable: false,
        // },
        {
          text: "",
          align: "center",
        }
      ],
      pagination: {
          ...configs.PAGINATION,
          sortBy: ["ID"]
      },
      selectedTab: 0,
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      listStatus: configs.ORDER_STATUS,
      line_types: configs.LINE_TYPES,
      viewName: "order_list",
      filterConditions: [],
      quickFilterConditions: [],
      dialogExport: false,
      totalDeposit: 0,
      dialogNew: false,
      dialogImport: false,
      newProduct: {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      },
      newOrder: {
        UID: 0,
        Products: []
      },
      export_options: {
        start_date: moment.utc(Date.now()).subtract(1, 'days').format(configs.SHORT_DATE_FORMAT),
        end_date: moment.utc(Date.now()).format(configs.SHORT_DATE_FORMAT)
      },
      date_validation: [v => v.match(/^(0?[1-9]|[12][0-9]|3[01])[\-](0?[1-9]|1[012])[\-]\d{4}$/) || "DD-MM-YYYY"]
    };
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    orders: function(val) {
      this.selectedOrders = [];
    }
  },
  computed: {
    ...mapState({
      orders: state => state.main_order.all.data,
      orderSummary: state => state.main_order.all.summary,
      total_rows: state => state.main_order.all.total,
      loading: state => state.main_order.loading,
      staffs: state => state.commons.all_users,
      p_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
        }),
      cs_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.CustomerService) == configs.ROLE_TYPE.CustomerService;
        }),
      s_staffs: state =>
        _.filter(state.commons.all_users, function(o) {
          return (o.RoleType & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale;
        }),
      customers: state => state.customer.master.data,
      guarantees: state => {
          let tmp = [{name: 'Không sử dụng', value: 0}];
          if(state.feeGuarantee.all.data) {
          state.feeGuarantee.all.data.forEach(element => {
              tmp.push({name: element.PackageName, value: element.ID});
          });
          }
          return tmp;
      }
    }),
    pages() {
      return Math.ceil(
        this.total_rows / this.options.itemsPerPage
      );
    },
    bulkActionType() {
      if(this.managerRole) {
        return [
          {value: 4, name: 'Tỷ lệ cọc'}
        ]
      }
      return [
          {value: 1, name: 'Chờ đặt cọc'},
          {value: 3, name: 'Đã mua hàng'},
          {value: 2, name: 'Tỷ giá'},
          {value: 4, name: 'Tỷ lệ cọc'}
        ]
    },
    filter_headers() {
      return [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Loại đơn",
          value: "LineType",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.LINE_TYPES
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: configs.ORDER_STATUS
        },
        {
          text: "User khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Tên khách hàng",
          value: "CustomerName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "SĐT khách hàng",
          value: "PhoneNumber",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mua hàng",
          value: "BuyerName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "CSKH",
          value: "CSName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Sale",
          value: "SaleName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã đơn TQ",
          value: "OrderCodeCN",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã bao hàng",
          value: "BigPackageCode",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Tên shop",
          value: "ShopName",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Website",
          value: "Site",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Ghi chú KH",
          value: "Note",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"],
        },
        {
          text: "Ghi chú đơn",
          value: "AdminNote",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Đóng gỗ",
          value: "IsFragileGoods",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Kiểm hàng",
          value: "IsCheck",
          filterable: true,
          values: [{value: 0, name: 'N'}, {value: 1, name: 'Y'}],
          dataType: configs.DATA_TYPE["Enum"]
        },
        {
          text: "Bảo hiểm",
          value: "GuaranteeType",
          filterable: true,
          values: this.guarantees,
          dataType: configs.DATA_TYPE["Enum"]
        }
      ];
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
    managerRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Manager) == configs.ROLE_TYPE.Manager;
    },
    storeVNRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.StoreVN) == configs.ROLE_TYPE.StoreVN;
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    saleRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Sale) == configs.ROLE_TYPE.Sale;
    },
    purchaseRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Purchase) == configs.ROLE_TYPE.Purchase;
    },
    orderRole() {
      return this.$store.state.authentication.role.Orders;
    },
    customerId() {
      return this.$route.query.uid && this.$route.query.uid != '' ? Number(this.$route.query.uid) : 0;
    },
    selectedStatus() {
      return this.$route.query.status && this.$route.query.status != '' ? Number(this.$route.query.status) : 0;
    },
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      if(this.customerId > 0) {
        param.filter.push({
          column: "UID",
          value: this.customerId,
          condition: "equal",
        });
        param.uid = this.customerId;
      }
      if(this.selectedStatus > 0) {
        param.filter.push({
          column: "Status",
          value: this.selectedStatus,
          condition: "equal",
        });
      }
      this.$store.dispatch("main_order/getListOrders", param);
      this.$store.dispatch("feeGuarantee/getList");
      this.getCustomerList();
    },
    gotoDetail: function(id) {
      let routeData = this.$router.resolve({
        name: "OrderDetail",
        params: {
          Pid: id,
          title: `Chi tiết đơn hàng (#${id})`
        }
      });
      window.open(routeData.href, "_blank");
    },
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
        ID: staffId
      });
      return staff ? staff.FullName : "";
    },
    saveItem(item) {
      this.$store.dispatch("main_order/updateOrderDetail", item);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      if(_.filter(this.filterConditions, (p) => { return p.column == 'Status' && p.value == 2}).length > 0) {
        this.pagination.sortBy = ['DepositDate'];
      }
      else {
        this.pagination.sortBy = ['ID'];
      }
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    get_order_status_color(value){
      const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
      return objStatus ? objStatus.color : 'black';
    },
    exportDialog() {
      this.dialogExport = true;
    },
    exportFile() {
      let param = {filter: this.filterConditions, quickFilter: this.quickFilterConditions};
      if(this.customerId > 0) {
        param.filter.push({
          column: "UID",
          value: this.customerId,
          condition: "equal",
        });
        param.uid = this.customerId;
      }
      this.$store.dispatch("main_order/export_order", param);
    },
    getCustomerList() {
      this.$store.dispatch("customer/getCustomerList", {
          is_master: 1,
          fields: ["ID", "Username", "BuyerID", "CustomerServiceID", "ReceivePlaceID", "ChinaStoreID"]
      });
    },
    appendProduct() {
      this.newOrder.Products.push(this.newProduct);
      this.newProduct = {
        Link: '',
        Image: '',
        Property: '',
        Price: 0,
        Quantity: 1
      }
    },
    createData() {
      this.dialogNew = true;
    },
    createNewOrder() {
      if(this.newOrder.Products.length == 0) {
        sendErrorNotice("Hãy nhập danh sách sản phẩm!");
        return;
      }
      if(this.newOrder.UID == 0) {
        sendErrorNotice("Hãy chọn khách hàng!");
        return;
      }
      const cust = _.find(this.customers, {'ID': this.newOrder.UID});
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.newOrder.Username = cust.Username;
      this.newOrder.BuyerID = cust.BuyerID;
      this.newOrder.CustomerServiceID = cust.CustomerServiceID;
      this.newOrder.ChinaStoreID = cust.ChinaStoreID;
      this.newOrder.ReceivePlaceID = cust.ReceivePlaceID;

      this.$store.dispatch("main_order/createNew", {'data': this.newOrder, 'param': param});
      this.newOrder = {
        UID: 0,
        Products: []
      };
      this.dialogNew = false;
      sendSuccessNotice('Tạo mới đơn hàng thành công.');
    },
    chooseImage(item) {
        this.newProduct.Image = '';
        this.$refs.fileInput.click();
    },
    previewImage(event) {
        this.imageData = event.target.files[0];
        this.$refs.fileInput.value = null;
        this.onUpload()
    },
    onUpload() {
        const arrFileType = this.imageData.name.split('.');
        const storageRef=firebase.storage().ref(`${configs.SYSTEM_CONFIG.firebase_prefix}/${makeid(30)}.${arrFileType[arrFileType.length - 1]}`).put(this.imageData);
        storageRef.on(`state_changed`, snapshot => {
                
            },
            error => {
              sendErrorNotice('File ảnh chỉ được tối đa 1Mb!');
            },
            () => {
                storageRef.snapshot.ref.getDownloadURL().then((url) => {
                    this.newProduct.Image =url;
                    this.hideImage = true;
                    this.$nextTick(() => this.hideImage = false);
                });
            }
        );
    },
    getImages(index) {
        return this.newOrder.Products[index].Image;
    },
    importFileDialog() {
      this.dialogImport = true;
    },
    importFile(filelist) {
      for(const f of filelist) {
          const formData = new FormData();
          formData.append('excel_file', f);
          formData.append('filename', f.name);
          this.$store.dispatch("main_order/import_order", formData);
      }
      this.dialogImport = false;
    },
    deleteOrder() {
      window.getApp.$emit("REQUEST_DELETE_DATA");
    },
    depositDialog() {
      if(!this.adminRole && !this.paymentRole && !this.managerRole && !this.purchaseRole) {
        sendErrorNotice("Bạn không có quyền thực hiện chức năng này!");
        return;
      }
      if(this.selectedOrders.length == 0) {
        sendErrorNotice("Hãy chọn các đơn muốn cập nhật!");
        return;
      }
      this.dialogDeposit = true;
    },
    depositBlance() {
      if(this.purchaseRole && this.selectedActionType != 1 && this.selectedActionType != 3) {
        sendErrorNotice("Bạn không có quyền thực hiện chức năng này!");
        return;
      }
      if(this.selectedActionType == 2 && this.actionValueNumber <= 0) {
        sendErrorNotice("Hãy nhập tỷ giá tệ!");
        return;
      }
      if(this.selectedActionType == 4 && this.actionValueNumber <= 0) {
        sendErrorNotice("Hãy nhập tỷ lệ cọc!");
        return;
      }

      if(this.selectedActionType == 1) {
        var needDepositOrder = _.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia; });
        var ids = _.map(needDepositOrder, 'ID');
        if(ids.length == 0) {
          sendErrorNotice("Không thể cập nhật danh sách đơn hàng!");
          return;
        }
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          Status: configs.ORDER_STATUS_ENUM.cho_dat_coc
        });
      }
      else if(this.selectedActionType == 2) {
        var needUpdateOrder = _.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || item.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia; });
        var ids = _.map(needUpdateOrder, 'ID');
        if(ids.length == 0) {
          sendErrorNotice("Không thể cập nhật danh sách đơn hàng!");
          return;
        }
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          ExchangeRate: this.actionValueNumber,
          ReCal: true
        });
      }
      else if(this.selectedActionType == 3) {
        var needUpdateOrder = _.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_mua_hang; });
        var ids = _.map(needUpdateOrder, 'ID');
        if(ids.length == 0) {
          sendErrorNotice("Không thể cập nhật danh sách đơn hàng!");
          return;
        }
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          Status: configs.ORDER_STATUS_ENUM.da_mua_hang
        });
      }
      else if(this.selectedActionType == 4) {
        var needUpdateOrder = _.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.cho_dat_coc || item.Status == configs.ORDER_STATUS_ENUM.cho_bao_gia; });
        var ids = _.map(needUpdateOrder, 'ID');
        if(ids.length == 0) {
          sendErrorNotice("Không thể cập nhật danh sách đơn hàng!");
          return;
        }
        this.$store.dispatch("main_order/updateMultiple", {
          OrderIDs: ids,
          MinDepositRate: this.actionValueNumber,
          ReCal: false
        });
      }
      
      this.dialogDeposit = false;
    }
  },
  created() {
    this.$store.dispatch("commons/getAllUsers");
  },
  mounted() {
    this.filterConditions = [];
    this.quickFilterConditions = [];
    this.$root.$emit('REQUEST_ROOT_OPTION', {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_SAVE_DATA", this.exportFile);
    this.$root.$on("REQUEST_OTHER_ACTION", this.importFileDialog);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      var ids = _.map(_.filter(this.selectedOrders, (item) => { return item.Status == configs.ORDER_STATUS_ENUM.huy; }), 'ID');
      if(ids.length == 0) {
        sendErrorNotice("Chỉ có thể xoá đơn hàng đã huỷ!");
        return;
      }
      this.$store.dispatch("main_order/updateMultiple", {
        OrderIDs: ids,
        Action: 'DEL'
      });
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA");
    this.$root.$off("REQUEST_SAVE_DATA");
    this.$root.$off("REQUEST_OTHER_ACTION");
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
<style lang="stylus" scoped>
.image-product {
  width: 64px;
  height: 64px;
}
</style>